<template>
    <container>
        <h1>Our Values</h1>
		<row  v-for="(value, index) in valueObjects" :key="index" :justify="'around'" :align="'center'" :direction="(index%2 === 0 || $isMobile())? 'right' : 'left'">
            <column :width="2/5">
                <img :src="value.image" />
            </column>
			<column :width="2/5">
				<component :is="value.component" />
				<h3> {{value.title}} </h3>
				<p> {{ value.text }} </p>
			</column>
		</row>
	</container>
</template>
<script>
import valueObjects from '../../assets/values';
import { components } from '../../assets/values';
export default {
    name: 'values',
    data() {
        return {
            valueObjects
        }
    },
    components
}
</script>
<style scoped>
    .column {
		position: relative;
        margin: 4%;
	}
	.column > svg {
		position: absolute;
		height: 100%;
		left: 50%;
		transform:translateX(-50%);
		fill: rgba(85, 85, 85, 0.5);
		z-index: -1;
	}
    .column > img {
        width: 100%;
        box-shadow: 0 0 1em black;
    }

</style>